<router-outlet></router-outlet>
<app-notification class="hidden"></app-notification>
<app-balloon-notification class="hidden"></app-balloon-notification>

<app-internal-external-switch class="hidden"></app-internal-external-switch>
<app-close *ngIf="!sharedLinkVersion"></app-close>
<app-isomasters-logo *ngIf="sharedLinkVersion" class="hidden"></app-isomasters-logo>
<app-language-selector *ngIf="sharedLinkVersion" class="hidden"></app-language-selector>
<app-watermark *ngIf="hasToken()" class="hidden"></app-watermark>
<div class="hidden bottom-right-element">
  <div class="white-square bottom"></div>
  <div class="white-square top"></div>
</div>
<app-summary-container *ngIf="step === this.stepService?.maxStep"></app-summary-container>
